
import { Component, Vue } from "vue-property-decorator";
// import Navbar from "@/components/Utility/Navbar.vue";
// import Footer from "@/components/Utility/Footer.vue";

@Component({
  components: {
    // Navbar,
    // Footer,
  },
})
export default class MasterManagement extends Vue {}
